import SkipToContentBg from "./skipToContent0.jpg";
import SkipToContentLink from "./skipToContent1.png";

export const SkipToContentImage = {
  Bg: SkipToContentBg,
  Link: SkipToContentLink,
};
